export interface SignInUser {
  email: string;
  password: string;
  navigate: any;
}

export interface User {
  id?: number;
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  country: any;
  countryCode?: any;
  dateCreated?: string;
  totalOrders?: number;
  password?: string;
  navigate?: any;
  profileImage?: any;
}
export interface Token {
  refreshToken: string;
  accessToken: string;
  accessTokenExpiry: string;
}

export interface UserInfoType {
  user: User;
  token: Token;
}

export interface GoogleUser {
  user?: any;
  googleUser?: {
    firstName: string;
    lastName: string;
  };
  username: string;
  country: any;
  navigate?: any;
}

export enum ResetPasswordTypes {
  ID = 1,
  EMAIL,
  USERNAME,
}
